
angular.module("dyb.util.dates", ['classy']);